import { createAction, props } from '@ngrx/store';
import { QcResponseGrid } from '../models/grid.model';

export const GridSearch = createAction('[Shared: Grid]: Grid Search');

export const GridSuccess = createAction('[Shared: Grid]: Grid Success', props<{ res: QcResponseGrid }>());

export const GridFailed = createAction('[Shared: Grid]: Grid Failed');

export const ClearGrid = createAction('[Shared: Grid]: Grid Cleared');

export const LoadDisplayedColumns = createAction(
  '[Shared: Grid]: Load Displayed Columns',
  props<{ columns: { [label: string]: string } }>(),
);

export const SelectedRowDataChanged = createAction('[Shared: Grid]: Selected Row Data Changed', props<{ row: any }>());

export const DeselectedRowData = createAction('[Shared: Grid]: Deselected Row Data');
